import { isCoreCanvasView } from '../../types';

// The legacy redirect segments under `/catalogs/:id` (SC-2670) — they still mount
// CatalogLayout (→ SectionRedirect) before bouncing to a canvas view, so the
// workspace shell is briefly on screen there too.
const CANVAS_REDIRECT_SEGMENTS = new Set(['table', 'changes']);

// A canvas *workspace* route — the bare catalog path or one of its real view
// segments — where CatalogLayout mounts the workspace and the app sidebar collapses
// to its Discord-style catalog+account icon rail (the section nav lives as top tabs
// inside the canvas, not a second rail — SC-2669). Deliberately NOT a broad
// `/catalogs/:id/*` match: an unknown subpath (e.g. `/catalogs/c1/settings`) 404s
// WITHOUT mounting the workspace, so the sidebar must stay full there to preserve
// the user's recovery nav (SC-2669 review).
export function isCanvasWorkspaceRoute(pathname: string): boolean {
  // Board views (SC-2872) mount the workspace at the two-segment
  // `/catalogs/:id/boards/:boardId` form; a bare `/boards` is a 404 like any
  // other unknown segment, so it deliberately does NOT match here.
  if (/^\/catalogs\/[^/]+\/boards\/[^/]+\/?$/.test(pathname)) return true;
  const m = /^\/catalogs\/[^/]+(?:\/([^/]+))?\/?$/.exec(pathname);
  if (!m) return false;
  const seg = m[1];
  // Core views only: a `board:<id>` STORE id is never a URL segment (its URL is
  // the `boards/<id>` form above), so a pasted `/catalogs/c1/board:x` is an
  // unknown segment → 404 with the full sidebar preserved (the SC-2669 rule).
  return seg === undefined || isCoreCanvasView(seg) || CANVAS_REDIRECT_SEGMENTS.has(seg);
}
